/**
 * Kinds that only ever record the viewer's own command. The notification panel
 * lists the viewer's own activity, so these are an echo of something they just
 * did: shown, but never a reason to light the unread badge.
 */
const OWN_COMMAND_KINDS: ReadonlySet<string> = new Set(["deterrence_triggered", "deterrence_stopped"]);

interface NotificationLike {
  readonly kind: string;
  readonly createdAt: string;
}

/** Whether an item should show as read in the panel. */
export function isNotificationRead(item: NotificationLike, lastSeenDate: string | null): boolean {
  if (OWN_COMMAND_KINDS.has(item.kind)) return true;
  return lastSeenDate != null && item.createdAt <= lastSeenDate;
}

/** Whether the newest-first `items` hold anything the viewer has not seen. */
export function hasUnreadNotifications(items: readonly NotificationLike[], lastSeenDate: string | null): boolean {
  return items.some((item) => !isNotificationRead(item, lastSeenDate));
}
